<template>
  <header class="header">
    <i class="logo"></i>
    <div class="user-center">
      <img v-bind:src="fbUerInfo.avatar" v-bind:alt="fbUerInfo.account" class="fb-avatar" />
      <p class="fb-name user-info">{{ fbUerInfo.name }}</p>
      <p class="fb-info user-info">{{ fbUerInfo.account }}</p>
    </div>

    <nav class="top-navs">
      <!-- full screen -->
      <a class="nav-item j-full" @click="showFullScreen">fullｽｸﾘｰﾝ</a>
      <span>|</span>

      <!-- website -->
      <a class="nav-item j-website" :href="websiteHref" target="_blank">HP</a>
      <span>|</span>

      <!-- fan service -->
      <a class="nav-item j-service" :href="fanHref" target="_blank">CS</a>
      <span>|</span>

      <!-- like & share -->
      <a class="nav-item like-item">
        ｼｪｱ
        <div class="like-box">
          <img :src="likeUrl" />
          <img :src="fbInfo.appImg" class="app-img" />
          <p class="app-name">{{ fbInfo.appName }}</p>
          <div
            class="fb-like"
            :data-href="fbInfo.like"
            data-width
            data-layout="button_count"
            data-action="like"
            data-size="small"
            data-show-faces="false"
            data-share="true"
          ></div>
        </div>
      </a>
      <span>|</span>

      <a class="nav-item link" @click="openGuidePopup">携帯でもﾛｸﾞｲﾝ可能!</a>
    </nav>
  </header>
</template>

<script>
export default {
  name: "fbHeader",
  data() {
    return {
      fullScreen: false,
      websiteHref: window.website || "",
      fanHref: window.appInfo.fansPage || "",
      fbbg: window.bg,
      likeUrl: window.likePopup || ""
    };
  },
  computed: {
    fbUerInfo() {
      return {
        avatar:
          window.facebookUser && window.facebookUser.id
            ? "//graph.facebook.com/" + window.facebookUser.id + "/picture"
            : "//www.gm99.com/images/noavatar.jpg",
        name: (window.facebookUser && window.facebookUser.name) || "",
        id: (window.facebookUser && window.facebookUser.id) || "",
        account: window.loginAccount || ""
      };
    },
    fbInfo() {
      return {
        appName: (window.appInfo && window.appInfo.appName) || "",
        appImg:
          (window.appInfo &&
            window.appInfo.fansPage &&
            window.appInfo.fansPage.replace("www", "graph").replace(/\/$/, "") +
              "/picture") ||
          "",
        like: window.appInfo.FANS_PAGE
      };
    }
  },
  methods: {
    showFullScreen() {
      // document.querySelector(".j-game-page").requestFullscreen();
      let gameEle = document.querySelector(".j-game-page");
      if (gameEle.requestFullscreen) {
        gameEle.requestFullscreen();
        return;
      }

      if (gameEle.webkitRequestFullscreen) {
        gameEle.webkitRequestFullscreen();
        return;
      }

      if (gameEle.msRequestFullscreen) {
        gameEle.msRequestFullscreen();
        return;
      }

      if (gameEle.mozRequestFullScreen) {
        gameEle.mozRequestFullScreen();
        return;
      }

      // let requestFullscreen = gameEle.requestFullscreen || gameEle.webkitRequestFullscreen ||gameEle.msRequestFullscreen||gameEle.mozRequestFullScreen;
      // if(requestFullscreen){
      //  requestFullscreen();
      // }else{
      alert(
        "該当ブラウザは、フルースクリーンモードをサポートしてないためお勧め：「Google　Chrome」にて再度お試しください。"
      );
      // }
    },
    openGuidePopup() {
      this.$parent.toggleGuidePopup();
    }
  }
};
</script>
